/**
 * Donate app typography.
 *
 * Set `enabled: false` to fall back to the global app font (Epilogue).
 * Swap `sans` / `mono` here — LayoutShell + donate layout pick this up automatically.
 *
 * Shared checkout/UI components inherit via CSS variables set on the donate parent
 * (`--font-sans`, `--default-font-family`, `--amount-font-family`). Outside donate,
 * those variables are unset and components keep the global theme fonts.
 */
export const DONATE_FONT_CONFIG = {
  enabled: true,
  sans: {
    family: 'Manrope',
    googleQuery: 'Manrope:wght@200..800',
    fallback: 'ui-sans-serif, system-ui, sans-serif',
  },
  mono: {
    family: 'Manrope',
    googleQuery: 'Manrope:wght@200..800',
    fallback: 'ui-sans-serif, system-ui, sans-serif',
  },
  /** Used by Stripe Elements when custom donate fonts are disabled */
  stripeFallback: 'Lato',
} as const;

export const donateFontsEnabled = (): boolean => DONATE_FONT_CONFIG.enabled;

export const donateFontSansStack = (): string =>
  `'${DONATE_FONT_CONFIG.sans.family}', ${DONATE_FONT_CONFIG.sans.fallback}`;

export const donateFontMonoStack = (): string =>
  `'${DONATE_FONT_CONFIG.mono.family}', ${DONATE_FONT_CONFIG.mono.fallback}`;

export const donateGoogleFontsHref = (): string | null => {
  if (!DONATE_FONT_CONFIG.enabled) {
    return null;
  }

  const { sans, mono } = DONATE_FONT_CONFIG;
  const families = new Set([`family=${sans.googleQuery}`, `family=${mono.googleQuery}`]);

  return `https://fonts.googleapis.com/css2?${[...families].join('&')}&display=swap`;
};

/** Stripe Elements `fontFamily` — sans when enabled, global fallback otherwise */
export const donateStripeFontFamily = (): string =>
  DONATE_FONT_CONFIG.enabled ? DONATE_FONT_CONFIG.sans.family : DONATE_FONT_CONFIG.stripeFallback;
